module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "ml-2 event-info",
    staticStyle: {
      "height": "100%",
      "min-height": "150px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "event-image-flex",
    attrs: {
      "xs3": "",
      "sm2": "",
      "md1": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "15px"
    }
  }, [_c('img', {
    staticClass: "event-image",
    staticStyle: {
      "border-radius": "15px",
      "height": "100px",
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.event.logo || '/static/images/event-icon.png'
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "event-content",
    attrs: {
      "xs9": "",
      "sm10": "",
      "md6": "",
      "lg7": "",
      "pl-3": ""
    }
  }, [_c('h5', {
    staticClass: "secondary--text event-name",
    staticStyle: {
      "font-weight": "900",
      "cursor": "pointer",
      "font-size": "17px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.viewEvent(_vm.event)
      }
    }
  }, [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), _c('div', {
    staticClass: "event-date date_range"
  }, [_c('b', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("actualDate")(_vm.event.eventdate)) + " " + _vm._s(_vm._f("formatTime")(_vm.event.starteventtime)) + " - " + _vm._s(_vm._f("formatTime")(_vm.event.endeventtime)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Registration Deadline:")]), _vm._v(" " + _vm._s(_vm.event.deadline || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Fee:")]), _vm._v(" " + _vm._s(_vm.event.fee || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Center:")]), _vm._v(" " + _vm._s(_vm.event.center || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Point of Contact:")]), _vm._v(" " + _vm._s(_vm.event.pointofcontact || 'N/A') + "\n        ")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-left": "-13px"
    },
    attrs: {
      "row": "",
      "hidden-md-and-up": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.event.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n                RSVP\n              ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    on: {
      "click": function($event) {
        _vm.seen = !_vm.seen
      }
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "16px",
      "link": _vm.link
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "xs3": "",
      "sm4": "",
      "md5": "",
      "lg4": "",
      "hidden-sm-and-down": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.event.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n                RSVP\n              ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    on: {
      "click": function($event) {
        _vm.seen = !_vm.seen
      }
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "40px",
      "link": _vm.link
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e798ad2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/events/EventTimelineComponent.vue
// module id = 1221
// module chunks = 17 24